module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "breadcrumb"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6921dff4"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/breadcrumb.vue
// module id = 1213
// module chunks = 1